import React from 'react'
import ReactDOM from 'react-dom'
import { Map, TileLayer } from 'react-leaflet-universal'

class MapView extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
      const position = []//get
      position.push(this.props.lat, this.props.lon)
      return (
        <div>
          <Map
            style={{height: "50vh", margin: "0 0 10px 0"}}
            center={position}
            zoom={4}>
            <TileLayer
              url="https://api.mapbox.com/styles/v1/danieltbrennan/cjgoz6bbh000e2so45soa6j7l/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFuaWVsdGJyZW5uYW4iLCJhIjoiY2pnb3o1NnkxMnh0OTMzcHFqc2QzZ2I1cCJ9.BHKu2mfEefIhiDC26x-PsA#1.8/55.965336/121.838289/0"
              attribution="MapBox" />
          </Map>
        </div>
      )
    }
  }

export default MapView



// WEBPACK FOOTER //
// ./src/components/MapView.js